<template>
  <div>
    <v-stepper v-model="paso" vertical>

            <v-stepper-step :complete="paso > 1" step="1">
        Cargar Permisos Provisionales
       
      </v-stepper-step>

      <v-stepper-content step="1">
        <div>
          <div class="text-h6">Ejemplo de nómina</div>
          <div class="text--secondary text-body-2">
            Puedes subir una nómina en formato Excel. La primera fila debe tener los
            títulos aquí indicados. Todos los campos son obligatorios y se debe mantener el orden de las columnas. En la fila 2 se incluye un ejemplo de datos.
          </div>

          <simulacion-excel class="my-2" />

          <button type="button" class="v-btn v-btn--outlined theme--light v-size--small primary--text"  @click="descargarEjemplo">
            <span class="v-btn__content"><!----><i aria-hidden="true" class="v-icon notranslate v-icon--left mdi mdi-download theme--light"></i> Descargar ejemplo </span></button>
        </div>
        <button 
        @click="paso++"
        type="button" class="my-4 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"><span class="v-btn__content"><!----> Continuar </span></button>

      </v-stepper-content>


      <v-stepper-step :complete="paso > 2" step="2">
        Selección de archivo
        <small v-if="paso >= 2 && file && file.name">
          {{ file.name }}
          <span v-if="hoja && hoja !== 'Sheet1'"> • {{ hoja }} </span>
          <span v-if="nomina">
            • {{ $formato.textoSingularPlural(nomina.filas, 'fila', 'filas en total') }}
          </span>
        </small>
      </v-stepper-step>

      <v-stepper-content step="2">
        <div v-if="paso == 2">
          <div class="d-inline-flex align-center" style="width: 100%; height: 85px">
            <v-file-input v-show="!loading" v-model="file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv,application/vnd.oasis.opendocument.spreadsheet"
              prepend-icon="mdi-paperclip" class="mt-4" label="Seleccionar archivo" outlined show-size
              hint="Tamaño máximo: 8 MB" persistent-hint @change="analizarFile" />

            <div v-if="!!loading" class="flex">
              <v-progress-circular :size="20" color="primary" indeterminate width="2" />
              <span class="text-caption text--secondary ml-1"> Analizando archivo... </span>
            </div>
          </div>

        </div>
      
      </v-stepper-content>

      <!--
      .
      .
      .
      .
      .
      .
      .
      #############################################################################################

                                          PASO 3

      #############################################################################################

      -->

      <v-stepper-step :complete="paso > 3" step="3"> Revisión </v-stepper-step>

      <v-stepper-content step="3">
        <div v-if="paso >= 3">
          <v-alert v-if="this.errores.length > 0" outlined type="error" class="my-8">
            Se encontraron errores en la validación del archivo.
            <ul class="mt-2">
              <li v-for="(error, index) in errores" :key="index">
                {{ error }}
              </li>
            </ul>
            <div class="mt-3">
              <v-btn color="primary" @click="volver">Volver a empezar</v-btn>
            </div>
          </v-alert>

          <v-alert v-if="this.errores.length === 0" outlined type="success" class="my-8">
            No hay errores, se puede continuar con la carga.
            <div class="mt-3">
              <v-btn color="primary" @click="cargar">Cargar</v-btn>
            </div>
          </v-alert>
        </div>
      </v-stepper-content>

      <!--

      .
      .
      #############################################################################################

                                          PASO 4

      #############################################################################################

      -->

      <v-stepper-step step="4"> Resultados </v-stepper-step>

      <v-stepper-content step="4">
        <div v-if="paso >= 4">
          <v-alert type="success">
            <span>Archivo cargado exitosamente.</span>
            <div>
              <span>{{ resultadoCarga.cantidad }} registros importados correctamente.</span>
            </div>

            <br />
            <v-btn outlined class="my-4" onclick="location.reload()"> Terminar </v-btn>
          </v-alert>
        </div>
      </v-stepper-content>

    </v-stepper>


    <v-divider class="my-8"></v-divider>
    <div>
      <div class="text-h6 mb-2">Nóminas cargadas previamente</div>
      
      <v-data-table
        :headers="headers"
        :items="nominas"
        :items-per-page="10"
        class="elevation-1"
        no-data-text="No hay nóminas cargadas."
      >
        <template v-slot:item.created_at="{ item }">
          {{ new Date(item.created_at).toLocaleString('es-CL', { dateStyle: 'medium', timeStyle: 'short' }) }}
        </template>
        
        <template v-slot:item.nombre="{ item }">
          {{ item.nombre }}
          <div class="text--secondary text-caption">{{ item.archivo }}</div>
        </template>
        
        <template v-slot:item.cantidad="{ item }">
          <v-chip
            v-if="item.cantidad"
            small
            :color="item.cantidad > 0 ? 'primary' : 'grey'"
            text-color="white"
            class="text-end"
          >
            {{ item.cantidad }}
          </v-chip>
          <span v-else class="text--secondary">-</span>
        </template>
        
        <template v-slot:item.estado="{ item }">
          <v-chip
            small
            :color="getEstadoColor(item)"
            dark
          >
            {{ getEstadoTexto(item) }}
          </v-chip>
        </template>
        
        <template v-slot:item.actions="{ item }">
          <div class="text-no-wrap">
            <v-btn
              fab
              small
              text
              color="grey darken-1"
              title="Descargar archivo"
              @click="descargarNomina(item)"
            >
              <v-icon>mdi-cloud-download-outline</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>

import SimulacionExcel from './SimulacionExcel'

export default {
  components: {
    SimulacionExcel

  },
  data: () => ({
    paso: 1,
    file: null,
    fileMaxSize: 8 * 1024 * 1024,
    nominas: [],
    loading: false,
    resultadoCarga: null,
    headers: [
      {
        text: 'Creación',
        align: 'start',
        sortable: true,
        value: 'created_at'
      },
      {
        text: 'Nómina',
        align: 'start', 
        sortable: true,
        value: 'nombre'
      },
      {
        text: 'Registros importados',
        align: 'start',
        sortable: true,
        value: 'cantidad'
      },
      {
        text: 'Estado',
        align: 'start',
        sortable: true,
        value: 'estado'
      },
      {
        text: '',
        align: 'end',
        sortable: false,
        value: 'actions'
      }
    ]
  }),
  computed: {

  },
  watch: {

  },
  methods: {

    descargarNomina(nomina){
    this.$axios.get( `bum/permisos-provisionales/descargarNomina/${nomina.id}`, { responseType: 'blob' })
        .then((res) => {
          const blob = new Blob([res.data], { type: res.headers['content-type'] })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = nomina.archivo
          link.click()
          this.$emit('notificar', 'Descarga exitosa.')
        })
        .catch((error) => {
          console.log(error)
          this.$emit('notificar:error', 'El archivo seleccionado no se encuentra disponible.')
        })
    },
    getNominas(){
      this.$axios
        .get(`bum/permisos-provisionales/nominas`)
        .then((response) => {
          this.nominas = response.data
        })
        .catch((error) => {
          console.warn(error)
        })
    },

    analizarFile() {
      const headers = { 'Content-Type': 'multipart/form-data' }
      const formData = new FormData()
      formData.append('archivo', this.file)

      this.loading = true
      this.$axios
        .post(`bum/permisos-provisionales/validarArchivo`, formData, {
          headers,
          timeout: this.sincrona ? (180 + 10) * 1000 : 30 * 1000,
        })
        .then((response) => {
          this.paso++
          this.errores = response.data.errores
        })
        .catch((error) => {
          console.warn(error)
          // const mensajeError = getError(error)
          // const status = error?.response?.status
        })
        .finally(() => {
          this.loading = false
        })
    },
    // ...existing code...
descargarEjemplo() {
  this.$axios
    .post(
      `bum/permisos-provisionales/descargarEjemplo`,
      {},
      { responseType: 'blob' }
    )
    .then((response) => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'ejemplo.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
},
    volver(){ 
      this.paso = 1
      this.file = null
      this.errores = []
      this.resultadoCarga = null
    },
    cargar() {
      const headers = { 'Content-Type': 'multipart/form-data' }
      const formData = new FormData()
      formData.append('archivo', this.file)

      this.loading = true
      this.$axios
        .post(`bum/permisos-provisionales/cargarArchivo`, formData, {
          headers,
          timeout: this.sincrona ? (180 + 10) * 1000 : 30 * 1000,
        })
        .then((response) => {
          this.paso++
          this.resultadoCarga = response.data
        })
        .catch((error) => {
          console.warn(error)

        })
        .finally(() => {
          this.loading = false
        })
    },

    getEstadoColor(item) {
      // Como solo hay estado "Importada", siempre devolvemos success
      return 'success'
    },

    getEstadoTexto(item) {
      // Como solo hay estado "Importada", siempre devolvemos "Importada"
      return 'Importada'
    }
  },
  mounted() {
    this.getNominas()
  },
}
</script>
